import t from "./EditTextAttr.ce.vue2.js";
import o from "./EditTextAttr.ce.vue3.js";
import e from "../../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ e(t, [["styles", [o]], ["__scopeId", "data-v-d5de1e29"]]);
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/EditTextAttr.ce.vue.js
// module id = 1189
// module chunks = 41